<div class="flex-column d-flex justify-content-center text-center mb-4 drop-container" *ngIf="!selfieImage">
    <div *ngIf="!takeSelfie && !selfieSupportError">
        <div class="my-2" *ngIf="!selfieImage">
            <img src="./assets/images/cam_icon.svg" class="img-fluid" />
        </div>
        <!-- <div class="mb-2"  *ngIf="selfieImage" (click)="imgModal()">
            <img [src]="selfieImage" height="200" />
        </div> -->
        <small class="text-secondary" *ngIf="!rmModule && !selfieImage"><strong>Click take selfie for liveliness
                check</strong></small>
        <small class="text-secondary" *ngIf="rmModule && !selfieImage">Please upload client photo</small>

        <div *ngIf="!rmModule">
            <button class="btn btn-primary px-5 my-2 fs-1" *ngIf=" !selfieSupportError && latitude && !cameraDisabled"
                (click)="captureSelfie()"> {{selfieImage ? 'Retake Selfie':'Take Selfie'}}</button>
            <!-- <label class="btn btn-primary px-5 my-2 fs-1" *ngIf="latitude && isMobile">Take Selfie
                <input type="file" accept="image/*" capture="capture" class="d-none" id="selfie" (change)="captureSelfie()">
            </label> -->
        </div>
        <div *ngIf="rmModule">
            <label class="btn btn-primary px-5 my-2 fs-1" *ngIf="latitude">Upload Photo
                <input type="file" accept="image/*" class="d-none" id="selfie" (change)="upldPhoto($event)">
            </label>
        </div>

        <div *ngIf="!latitude || cameraDisabled" class="text-error">
            To capture the selfie please go to browser setting, select site settings and allow location and camera
            access
        </div>
    </div>
    <div *ngIf="selfieSupportError">
        <span class="text-danger">Your device doesn't have support to take selfie</span>
    </div>

    <div *ngIf="takeSelfie">
        <div class="row">
            <div class="col" *ngIf="!capture">
                <webcam [height]="400" [width]="isMobile ? 250 : 300" [trigger]="triggerObservable"
                    (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                    [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" [imageQuality]="1"
                    (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"></webcam>
                <div class="mt-4">
                    <button class="btn btn-primary my-2 px-5" (click)="triggerSnapshot();">Capture Selfie</button>
                </div>
            </div>
            <div class="col" *ngIf="webcamImage && !retake && capture">
                <!-- <img [src]="webcamImage.imageAsDataUrl" class="selfieImg" [width]="400" [height]="300"/>
                    <div class="mt-4">
                        <button class="btn btn-primary my-2 px-5" (click)="upldImg();">Upload Selfie</button>
                    </div> -->
                <div class="mt-3">
                    <!-- <img [src]="rotatedImage || webcamImage.imageAsDataUrl"
                     class="selfieImg"
                     [style.transform]="'rotate(' + rotationAngle + 'deg) scaleX(-1)'"
                     [width]="300" [height]="300"/> -->
                    <img [src]="rotatedImage || webcamImage.imageAsDataUrl" class="selfieImg" width="300"
                        height="300" />
                </div>

                <div class="mt-5">
                    <button class="btn btn-outline-primary mx-2" (click)="rotateImage('left')">⟲ Rotate Left</button>
                    <button class="btn btn-outline-primary mx-2" (click)="rotateImage('right')">⟳ Rotate Right</button>
                    <!-- <button class="btn btn-outline-primary mx-2" (click)="rotateImage()">🔄 Rotate</button> -->
                </div>

                <div class="mt-4">
                    <button class="btn btn-primary my-2 px-5" (click)="upldImg();">Upload Selfie</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="d-flex align-items-end h-100 mt-5 pt-5 row">
        <div class="col text-start">
            <button class="btn btn-white border-primary text-primary px-5" (click)="backStage()">Back</button>
        </div>
        <div class="col text-end">
            <button class="btn btn-primary px-4" [disabled]="!selfieImage" (click)="stageValidate()">Next</button>
        </div>
    </div> -->
</div>


<div class="row mx-0" *ngIf="selfieImage">
    <div class="col-md-12 col-lg-12">
        <p class="h6"> Live Selfie</p>
        <div class="row d-flex justify-content-center">
            <div class="col-md-12 col-lg-12 mb-2 d-flex justify-content-center">
                <img [src]="selfieImage" class="img-fluid" style="transform: scaleX(-1);" (click)="imgModal()" />
            </div>
            <!-- <div class="col-md-6 col-lg-6">
            </div> -->
            <div class="col-md-6 col-lg-6">
                <button class="btn btn-primary w-100 rounded-pill my-2 fs-1"
                    *ngIf=" !selfieSupportError && latitude && !cameraDisabled" (click)="captureSelfie()">Retake
                    Selfie</button>
            </div>
        </div>
    </div>
    <!-- <div class="d-flex align-items-end h-100 mx-0 mt-5 pt-5 row">
        <div class="col text-start">
            <button class="btn btn-white border-primary text-primary px-5" (click)="backStage()">Back</button>
        </div>
        <div class="col text-end">
            <button class="btn btn-primary px-4" [disabled]="!selfieImage" (click)="stageValidate()">Next</button>
        </div>
    </div> -->
</div>
<div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
    <div class="col text-start">
        <button class="btn btn-white border-primary text-primary px-5" (click)="backStage()">Back</button>
    </div>
    <div class="col text-end">
        <button class="btn btn-primary px-4" [disabled]="!selfieImage" (click)="stageValidate()">Next</button>
    </div>
</div>
<div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
            <div class="modal-header border-0">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-4">
                <img [src]="selfieImage" style="transform: scaleX(-1);" class="mw-100 mh-100">
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="anothercountry" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <h1 class="modal-title fs-5" id="exampleModalLabel">Welcome to SBI Securities</h1> -->
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
            </div>
            <div class="modal-body">
                <h3>{{geoerror}}</h3>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="homepage()">Ok</button>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>